module.exports = __webpack_public_path__ + "img/icon_building_6.0f10f4ff.png";